import { render, staticRenderFns } from "./AmountKeyBoard.vue?vue&type=template&id=2981d148&scoped=true&"
import script from "./AmountKeyBoard.vue?vue&type=script&lang=ts&"
export * from "./AmountKeyBoard.vue?vue&type=script&lang=ts&"
import style0 from "./AmountKeyBoard.vue?vue&type=style&index=0&id=2981d148&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2981d148",
  null
  
)

export default component.exports